<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-4">
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': !router.url.includes('mawop')}" (click)="toggleMawop('equipment-registration')">
                Equipment Registration
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('mawop')}" (click)="toggleMawop('mawop')">
                MAWOP
            </a>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>